export default [
    {
        path: 'oficios',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'OficioController' }
    }, ,
    {
        path: 'oficios/edit/:id',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'OficioController' },
    },
    {
        path: 'oficios/show/:id',
        component: require('./Show').default,
        meta: {
            middleware: 'auth',
            controller: 'OficioController'
        }
    },

    {
        path: 'relatorios/oficios',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/oficios/home',
        meta: { middleware: 'auth', controller: 'RelatorioOficioController' },
        children: [{
            path: 'home',
            name: 'relatorios_home_oficios',
            component: require('./reports/includes/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioOficioController' },
        }, {
            path: 'graficos',
            name: 'graficos_oficios',
            component: require('./reports/includes/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioOficioController' },
        }
        ]
    }
];


